export default __webpack_public_path__ + "static/media/45.015fb119.jpg";